import { PatientsService } from "./../patients.service";
import { LoginService } from "src/app/login.service";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ExamsService } from "../exams.service";
import { AutotextService } from "../autotext.service";
import { Subscription } from "rxjs";
import { AngularEditorConfig } from "@kolkov/angular-editor";

@Component({
    selector: "app-eyes-general",
    templateUrl: "./eyes-general.component.html",
    styleUrls: ["./eyes-general.component.scss"],
    standalone: false
})
export class EyesGeneralComponent implements OnInit, OnDestroy {
  readonly defaultTerms =
    "פענוח זה מתייחס לממצאי הצילום בלבד ללא בדיקת הבנדק/ת.\nבאבחנה סופית והחלטות טיפוליות יש להסתמך על ממצאי הבדיקה הקלינית.\nיש להעביר תוצאות הבדיקה בהקדם לרופא/ה המטפל/ת.";
  editorConfig: AngularEditorConfig = {
    editable: true,
    height: "fit-contnet",
    toolbarHiddenButtons: [
      ["subscript", "superscript", "strikeThrough"],
      [
        "backgroundColor",
        "customClasses",
        "link",
        "unlink",
        "insertImage",
        "insertVideo",
        "removeFormat",
        "toggleEditorMode",
      ],
    ],
  };
  GenForm: UntypedFormGroup;
  sub = new Subscription();
  awlForm: UntypedFormGroup;
  xmlMode;
  xmlLoading = false;
  aiSummaryLoading = false;
  formLoadedSub: Subscription = new Subscription();

  constructor(
    private fb: UntypedFormBuilder,
    public es: ExamsService,
    public atS: AutotextService,
    public ls: LoginService,
    public PatientsService: PatientsService
  ) {
    this.GenForm = this.fb.group({
      MedicalHistory: [""],
      TechComment: [""],
      LeftEyeFov: [""],
      RightEyeFov: [""],
      LeftEyeMacular: [""],
      RightEyeMacular: [""],
      LeftEyeNerve: [""],
      RightEyeNerve: [""],
      SummaryHtml: [""],
      referralRequest: [""],
      software: [""],
      ProcedureResult: [""],
      ReffDoc: [""],
      Terms: [""],
    });

    this.awlForm = this.fb.group({
      HMO: [""],
      AutoIndex: [""],
      refDocLastName: [""],
      BranchProviderName: [""],
      BranchProviderID: [""],
      refDocName: [""],
      Code: [""],
      PRN: [""],
      PRN2: [""],
      ExamCode: [""],
      Code2: [""],
      refDocName2: [""],
      BranchProviderID2: [""],
      BranchProviderName2: [""],
      refDocLastName2: [""],
    });
  }

  async ngOnInit() {
    this.sub.add(
      this.es.formLoaded$.subscribe(() => {
        const termsControl = this.GenForm.get("Terms");
        if (this.ls.isSite && !termsControl.value && !this.es.isClosed) {
          termsControl.setValue(this.defaultTerms);
        }
      }),
    );
    this.es.fillForm(this.GenForm, "eyesGeneral", false, true, [], ["ProcedureResult"]);
     this.es.fillAwlForm(this.awlForm, "AwlSchedule");
    this.sub.add(
      this.es.examLoaded$.subscribe(() => {
        this.es.fillAwlForm(this.awlForm, "AwlSchedule");
        this.es.fillForm(this.GenForm, "eyesGeneral", false, true, [], ["ProcedureResult"]);
      }),
    );
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.formLoadedSub) {
      this.formLoadedSub.unsubscribe();
    }
  }

  downloadXml(examId = this.es.examID, xmlMode = this.xmlMode): void {
    if (!examId || !xmlMode) return;
    this.xmlLoading = true;
    this.es.xmlDownloadByExamId(examId, xmlMode).subscribe((xml: any) => {
      const blob = new Blob([xml], { type: "application/xml" });
      const fileName = this.massageID() + xmlMode;
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${fileName}.xml`;
      link.click();
      this.xmlLoading = false;
    }),
      (error: any) => {
        console.error("Error downloading XML:", error);
        this.xmlLoading = false;
        // You may add additional error handling if needed
      };
  }

  massageID = (examId = this.es.examID, patId = this.PatientsService.getPat().ID) => {
    let examCode = examId.toString(32);
    return `${patId}${examCode}`;
  };

  // AR-24 change 3: AI medical-history summary from the patient's answered questionnaire.
  getAiSummary() {
    if (this.aiSummaryLoading) return;
    this.aiSummaryLoading = true;
    this.es.getAiSummary(this.es.ExamType, this.PatientsService.getPat()?.PID).subscribe(
      (res: any) => {
        this.aiSummaryLoading = false;
        if (res && res.summary) {
          const control = this.GenForm.get("MedicalHistory");
          const existing = (control.value || '').toString().trim();
          const previous = (res.previousSummary || '').toString().trim();
          // Replace only our own previously-pasted AI block (exact match), so a
          // doctor's hand-typed notes are never overwritten; otherwise append.
          if (previous && existing === previous) {
            control.setValue(res.summary);
          } else {
            control.setValue(existing ? existing + '\n\n' + res.summary : res.summary);
          }
        } else if (res && res.reason) {
          alert('Could not generate a summary (' + res.reason + ').');
        }
      },
      () => {
        this.aiSummaryLoading = false;
      }
    );
  }
}
